import React from "react";
//#region types
import { SimpleAccordionTableRowContentProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { TableRow, TableCell } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import SimpleTooltip from "components/common/tooltips/tooltip";
import { IconDefinitionConstants } from "utils/constants";
import { Icon } from "components/common";

const SimpleAccordionTableRowContent: React.FC<SimpleAccordionTableRowContentProps> = ({ subContent }) => {
  return (
    <>
      <TableRow
        className={clsx(cssExports.simpleAccordionTableRowContent, cssExports.simpleAccordionTableRowContentStart)}
      >
        <TableCell className={cssExports.tableCell} colSpan={3} />
      </TableRow>
      {subContent?.map((item, index) => (
        <TableRow className={cssExports.simpleAccordionTableRowContent} key={index}>
          <TableCell className={cssExports.tableCell}></TableCell>
          <TableCell
            colSpan={item.value !== undefined ? 1 : 2}
            className={clsx(cssExports.tableCell, item.value === undefined && cssExports.paragraphCell)}
          >
            <span>
              {item.title}{" "}
              {item.tooltip ? (
                <SimpleTooltip text={item.tooltip} placement="right">
                  <span>
                    <Icon icon={IconDefinitionConstants.WInfo} className={cssExports.tooltipIcon} />
                  </span>
                </SimpleTooltip>
              ) : (
                <></>
              )}
            </span>
          </TableCell>
          {item.value !== undefined ? (
            <TableCell className={clsx(cssExports.tableCell, cssExports.valueCell)}>{item.value}</TableCell>
          ) : (
            <></>
          )}
        </TableRow>
      ))}
      <TableRow
        className={clsx(cssExports.simpleAccordionTableRowContent, cssExports.simpleAccordionTableRowContentEnd)}
      >
        <TableCell className={cssExports.tableCell} colSpan={3} />
      </TableRow>
    </>
  );
};

export default SimpleAccordionTableRowContent;
